import { useState } from "react";
import { Sparkles, Sun, Moon, ChevronUp } from "lucide-react";

export default function DailyBriefingPanel() {
  const [mode, setMode] = useState("morning");
  const [open, setOpen] = useState(true);

  const briefingText =
    mode === "morning"
      ? "Your day is calm with no events scheduled and one low-priority task. Take it slow and ease into the morning."
      : "Your day was calm with no events to attend and just a low-priority task of reading a book. Rest well.";

  return (
    <div className="console-card p-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-neon-magenta" />
          <span className="uppercase text-sm tracking-wider">
            Daily Briefing
          </span>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="icon-button subtle"
          aria-label="Toggle briefing"
        >
          <ChevronUp
            className={`w-4 h-4 transition-transform ${
              open ? "" : "rotate-180"
            }`}
          />
        </button>
      </div>

      {open && (
        <>
          {/* Mode Toggle */}
          <div className="flex gap-2 mb-4">
            <button
              onClick={() => setMode("morning")}
              className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-full text-xs transition ${
                mode === "morning"
                  ? "border border-yellow-400/60 text-yellow-300 shadow-[0_0_12px_rgba(234,179,8,0.3)]"
                  : "border border-white/10 text-soft hover:text-white"
              }`}
            >
              <Sun className="w-3 h-3" />
              Morning
            </button>

            <button
              onClick={() => setMode("evening")}
              className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-full text-xs transition ${
                mode === "evening"
                  ? "border border-indigo-400/60 text-indigo-300 shadow-[0_0_12px_rgba(99,102,241,0.3)]"
                  : "border border-white/10 text-soft hover:text-white"
              }`}
            >
              <Moon className="w-3 h-3" />
              Evening
            </button>
          </div>

          {/* Briefing Text */}
          <p className="text-sm text-white/90 leading-relaxed">
            {briefingText}
          </p>
        </>
      )}
    </div>
  );
}
